import { z } from 'zod';
import { nameSchema, ageSchema, genderSchema } from './formSchemas';
import { INTERESTS } from '../Utils/personaUtils';

/**
 * Zod schema for Persona form validation
 */
export const personaSchema = z.object({
    name: nameSchema,
    age: ageSchema,
    gender: genderSchema,
    personalityTraits: z.array(z.string()).optional().default([]),
    interests: z.array(z.string()).optional().default([]),
    image: z.string().optional().nullable()
});

export const profileInfoSchema = z.object({
    name: z.string().min(2, "Name is required"),
    dob: z.date().or(z.string().min(1, "Date of birth is required")),
    gender: z.string().min(1, "Gender is required"),
});

export const interestOptionsMapping = {
    "🎨 Art and Crafting": "art",
    "🎮 Gaming": "gaming",
    "📚 Reading": "reading",
    "🎵 Music": "music",
    "🎥 Movies and TV Shows": "movies",
    "🏋️‍♂️ Fitness and Exercise": "fitness",
    "🍳 Cooking and Baking": "cooking",
    "🌍 Traveling": "traveling",
    "📸 Photography": "photography",
    "🌱 Gardening": "gardening",
    "🐾 Pets and Animal Care": "pets",
    "🚴‍♂️ Outdoor Activities": "outdoor",
    "🧩 Puzzles and Board Games": "puzzles",
    "🛠️ DIY Projects": "diy",
    "✍️ Writing or Journaling": "writing",
    "🧘‍♀️ Meditation and Yoga": "meditation",
    "⚽ Sports": "sports",
    "💻 Technology and Gadgets": "tech",
    "🏖️ Beach and Water Activities": "beach"
};

export const getInterestOptions = (t) => INTERESTS.map(interest => {
    const key = interestOptionsMapping[interest];
    return { value: interest, label: t(`interestsList.${key}`, { defaultValue: interest }) };
});
